module.exports = __webpack_public_path__ + "img/scayle.b222d61d.svg";